"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderHistory = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = require("styled-components");
var styles_1 = require("../../styles");
var SelectedOrder_1 = require("./SelectedOrder");
var OrderHistoryHeader_1 = require("./OrderHistoryHeader");
var context_1 = require("./context");
var OrderHistoryList_1 = require("./OrderHistoryList");
var base_1 = require("../base");
var FaArrowRight_1 = require("@react-icons/all-files/fa/FaArrowRight");
var react_1 = require("react");
var context_2 = require("../../context/context");
var hooks_1 = require("../../hooks");
var utils_1 = require("../../utils");
var OrderHistoryButton = function (_a) {
    var onClick = _a.onClick, _b = _a.className, className = _b === void 0 ? "" : _b;
    var data = hooks_1.query.useOrdersHistory().data;
    var openOrders = (0, hooks_1.useOpenOrders)();
    var isLoading = !data;
    var text = (0, react_1.useMemo)(function () {
        if (!data) {
            return "Loading orders";
        }
        return "".concat((0, utils_1.size)(openOrders), " Open orders");
    }, [data, openOrders]);
    var _onClick = (0, react_1.useCallback)(function () {
        if (!isLoading) {
            onClick();
        }
    }, [isLoading, onClick]);
    return ((0, jsx_runtime_1.jsxs)(StyledOrderHistoryButton, __assign({ className: "twap-show-orders-btn ".concat(className), onClick: _onClick }, { children: [isLoading && (0, jsx_runtime_1.jsx)(base_1.Spinner, { size: 20 }), (0, jsx_runtime_1.jsx)("span", { children: text }), (0, jsx_runtime_1.jsx)(FaArrowRight_1.FaArrowRight, { className: "twap-show-orders-btn-arrow" })] })));
};
var OrderHistory = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, children = _a.children, isOpen = _a.isOpen;
    var _c = (0, context_2.useTwapContext)(), account = _c.account, isWrongChain = _c.isWrongChain;
    if (!account || isWrongChain)
        return null;
    return ((0, jsx_runtime_1.jsx)(context_1.OrderHistoryContextProvider, __assign({ isOpen: isOpen }, { children: (0, jsx_runtime_1.jsx)(StyledOrderHistory, __assign({ className: className }, { children: children })) })));
};
exports.OrderHistory = OrderHistory;
var StyledOrderHistory = (0, styled_components_1.styled)("div")({
    width: "100%",
});
var StyledOrderHistoryButton = (0, styled_components_1.styled)(styles_1.StyledRowFlex)({
    justifyContent: "flex-start",
    ".twap-show-orders-btn-arrow": {
        marginLeft: "auto",
    },
});
var Content = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b;
    var selectedOrderId = (0, context_1.useOrderHistoryContext)().selectedOrderId;
    return ((0, jsx_runtime_1.jsxs)(Container, __assign({ className: className }, { children: [(0, jsx_runtime_1.jsx)(SelectedOrder_1.SelectedOrder, { selectedOrderId: selectedOrderId }), (0, jsx_runtime_1.jsx)(OrderHistoryList_1.OrderHistoryList, {})] })));
};
var Container = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b;
    var order = (0, context_1.useOrderHistoryContext)().selectedOrderId;
    return ((0, jsx_runtime_1.jsx)(StyledContainer, __assign({ className: className, order: order ? 1 : 0 }, { children: children })));
};
exports.OrderHistory.Button = OrderHistoryButton;
exports.OrderHistory.Content = Content;
exports.OrderHistory.Header = OrderHistoryHeader_1.OrderHistoryHeader;
exports.OrderHistory.Container = Container;
var StyledContainer = (0, styled_components_1.styled)(styles_1.StyledColumnFlex)(function (_a) {
    var order = _a.order;
    return {
        width: "100%",
        position: "relative",
        height: order ? "auto" : "500px",
        maxHeight: "90vh",
    };
});
